import { render, staticRenderFns } from "./promo-advertisement.vue?vue&type=template&id=3daadc20&scoped=true"
import script from "./promo-advertisement.vue?vue&type=script&lang=js"
export * from "./promo-advertisement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daadc20",
  null
  
)

export default component.exports